import { BaseDto } from './base.dto';
import { City } from './city.dto';
import { ProjectDirectory } from './project-directory.dto';
import { ProjectNote } from './project-note.dto';
import { SubProject } from './sub-project.dto';

export class Project extends BaseDto {
  name?: string;
  street?: string;
  buildingNumber?: string;
  block?: string;
  plot?: string;
  buildingArea?: string;
  files?: ProjectDirectory;
  sharePoint?: ProjectDirectory;
  subProjects?: SubProject[];
  notes?: ProjectNote[];
  city?: City;
}
